/**
 * @typedef Counter
 * @property {'act_number'} ACT_NUMBER
 * @property {'worker_number'} WORKER_NUMBER
 */

/** @type {Readonly<Counter>} */
const counters = {
  ACT_NUMBER: 'act_number',
  WORKER_NUMBER: 'worker_number',
};

module.exports = counters;
